import React from 'react';
import { ArrowDown } from 'lucide-react';
import { SearchBar } from './SearchBar';
import { useSupabaseSearch } from '../context/SupabaseSearchContext';

export function Header() {
  const { query, error, loading } = useSupabaseSearch();

  return (
    <header className="relative text-white py-12 sm:py-24 px-4 overflow-hidden" role="banner" style={{
      backgroundImage: `url('/images/Backround.jpg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      <div className="relative max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-4xl md:text-6xl font-extrabold mb-6 px-4 whitespace-nowrap">
          <span style={{ color: '#E09CAF' }}>SÖKA</span>
          <span style={{ color: '#D4C78C' }}>STIFTELSE</span>
          <span style={{ color: '#7A98B0' }}>MEDEL</span>
          <span style={{ color: '#B08FA3' }}>.SE</span>
        </h2>

        <p className="text-base sm:text-xl mb-2 text-white max-w-2xl mx-auto px-4 font-semibold">
          Sveriges bästa verktyg och sökmotor för att hitta rätt stiftelser
        </p>

        <p className="text-sm sm:text-base mb-8 text-white px-4 font-medium">
          Hitta rätt stiftelse för ditt ändamål
        </p>

        <div className="max-w-2xl mx-auto mb-12 px-4">
          <SearchBar />
        </div>

        {!query && !error && !loading && (
          <div className="mt-8 flex justify-center items-center text-white gap-2">
            <ArrowDown className="animate-bounce w-5 h-5" aria-hidden="true" />
            <span className="text-sm font-medium">
              Utforska tillgängliga stiftelser
            </span>
          </div>
        )}
      </div>
    </header>
  );
}
